import {
    identifyUser,
    resetAnalytics,
    trackEvent
} from "@/common/lib/analytics";
import { trackSignUp } from "@/common/lib/google-analytics";

const analyticsPluginImpl = {};

analyticsPluginImpl.install = function analyticsPlugin(Vue) {
    Vue.prototype.$analytics = {
        trackEvent,
        identifyUser,
        resetAnalytics,
        trackSignUp
    };
};

export default analyticsPluginImpl;
